var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {}, _obj[_vm.$style.spinner] = true, _obj[_vm.$style.error] = _vm.error, _obj )},[_c('FontAwesomeIcon',{attrs:{"icon":_vm.icons.loading,"size":"5x","pulse":!_vm.error}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }